<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Devolución de mercadería de recorrido
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Liquidación Recorridos</span>
            <span> /</span>
            <span>Devolución de mercadería de recorrido</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <form [formGroup]='formHeader' novalidate>
            <div class="row filtros-body">
                <div class="col" style="max-width: 200px;">
                    <div class="md-form mb-0">
                        <input value="" type="text" id="nroRecorrido" class="form-control"
                            placeholder="Nro de recorrido" required #nroRecorrido formControlName="nroRecorrido"
                            onlyNumbers />
                        <label for="nroRecorrido">Nro de recorrido</label>
                        <div *ngIf="
                            formHeader.get('nroRecorrido').invalid &&
                            (formHeader.get('nroRecorrido').dirty ||
                            formHeader.get('nroRecorrido').touched)
                            ">
                            <mdb-error *ngIf="formHeader.get('nroRecorrido').hasError('required')">
                                Ingrese nro. de recorrido
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col d-flex" style="max-width: 150px;">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="showModalSeleccionarRecorrido()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;" *ngIf="recorridoSeleccionado">
                        {{recorridoSeleccionado.camion_patente}}
                    </h6>
                    <h6 class="text-danger" style="display: contents;"
                        *ngIf="busquedaIniciada && !recorridoSeleccionado">
                        <!-- <mdb-error> -->
                        Ingrese recorrido
                        <!-- </mdb-error> -->
                    </h6>
                </div>
                <div class="col" style="max-width: 200px;">
                    <div class="md-form mb-0">
                        <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" required
                            formControlName="fechaDesde">
                        </mdb-date-picker>
                        <div *ngIf="
                            formHeader.get('fechaDesde').invalid &&
                            (formHeader.get('fechaDesde').dirty ||
                            formHeader.get('fechaDesde').touched)
                            ">
                            <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">
                                Ingrese fecha
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row filtros-body" *ngIf="recorridoSeleccionado">
                        <div class="col dato">
                            <Strong class="title">Fecha</Strong>
                            <span class="value">{{recorridoSeleccionado.fecha | fecha}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Patente</Strong>
                            <span class="value">{{recorridoSeleccionado.camion_patente}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Chofer</Strong>
                            <span class="value">{{recorridoSeleccionado.chofer_rut}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Hora de salida</Strong>
                            <span class="value">{{recorridoSeleccionado.fecha_hora_salida | date:'HH:mm'}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Monto recorrido</Strong>
                            <span class="value">
                                $ {{recorridoSeleccionado.total_documentos | numerico}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>


    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
        <div></div>
        <button *ngIf="recorridoSeleccionado" mdbBtn size="sm" type="button" color="success" mdbWavesEffect
            (click)="iniciarDevolucion(1)">
            Iniciar devolución
        </button>
    </div>
</div>

<section *ngIf="showButton" style="z-index: 2;">
    <div class="example-button-row" style="position:fixed; right: 0px; z-index: 2;top: 30%;">
      <div class="example-flex-container" style="z-index: 2;">
        <div class="example-button-container">
          <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollTop()">
            <mat-icon class="icon_ArrowUp">arrow_upward</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>
  <section style="z-index: 3;" *ngIf="showButtonDown">
    <div class="example-button-row" style="position:fixed; right: 0px; z-index: 3;">
      <div class="example-flex-container" style="z-index: 3;">
        <div class="example-button-container">
          <button id="arrow_UP" mat-mini-fab class="button_arrowUp" color="primary" aria-label="Go to the top of the page" (click)="onScrollAbajo()">
            <mat-icon class="icon_ArrowUp">arrow_downward</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section infinite-scroll (scrolled)="onScrollDown($event)" style="z-index: 1;" >
    <div class="card mb-2 wow"  style="z-index: 1;">
        <div class="card-body"  *ngIf="listaRecorridos">

            <div class="">

                <table class="table table-striped table-hover table-sm align-middle TablePrincipal"
                mdbTableEditor
                mdbTable
                mdbTableScroll scrollX="true" scrolly="true"
                maxHeight="500" striped="true" bordered="true"
                stickyHeaderBgColor="#E0E0E0"
                stickyHeaderTextColor="#212529"
                stickyHeader="true">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col" style="width: 85px;">Fecha</th>
                            <th scope="col" style="width: 70px;">Tipo</th>
                            <th scope="col" style="width: 130px;">Nro. Dcto.</th>
                            <th scope="col" style="width: 120px;">RUT</th>
                            <th scope="col">Cliente</th>
                            <th scope="col" style="width: 190px;">Monto</th>
                            <!-- <th scope="col">Estado</th> -->
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr *ngIf="loading">
                            <td colspan="100%" style="text-align: center">
                                <mdb-spinner spinnerColor="blue"></mdb-spinner>
                            </td>
                        </tr> -->
                        <tr *ngIf="!loading && listaRecorridos?.length === 0">
                            <td colspan="100%" style="text-align: center">
                                No se encontró información
                            </td>
                        </tr>
                        <tr *ngFor="let recorrido of listaRecorridos ; let i = index" (click)="ClickedRow(i,recorrido)" [class.active]="i == HighlightRow">
                            <td>{{recorrido.fechaEmisionDocto | fecha}}</td>
                            <td>{{recorrido.tipoDteNombre}}</td>
                            <td>{{recorrido.folio}}</td>
                            <td>{{recorrido.rutEmisorFormato | rut}}</td>
                            <td>{{recorrido.nombreCliente}}</td>
                            <td class="text-right">{{recorrido.monto_documento | numerico}}</td>
                            <!-- <td>???</td> -->
                            <td>
                                <button [disabled]="!recorrido.permiteNCAnulacion" mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center ml-3" size="sm"
                                    (click)="showModalDevolverDocumento(recorrido, formHeader.get('fechaDesde').value)">
                                    Devolver documento
                                </button>
                                <button [disabled]="!recorrido.permiteNCParcial" mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                                    (click)="showModalDevolverProducto(recorrido, formHeader.get('fechaDesde').value)">
                                    Devolver productos
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="100%" style="text-align: center">
                              <div class="row pb-1 pt-1" id="spinnerX">
                                <div class="col-md-12 p-4">
                                  <ngx-spinner
                                  bdColor=""
                                  bdoOpacity="0.9"
                                  size="default"
                                  color="#581f87"
                                  type="ball-pulse-sync"
                                  [fullScreen]="false"
                                  >
                                </ngx-spinner>

                                </div>
                             </div>
                            </td>

                          </tr>
                    </tbody>
                    <!-- <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                        *ngIf="listaRecorridos?.length > 0"></app-pagination> -->
                        <tfoot *ngIf="listaRecorridos?.length > 0">
                            <tr>
                              <!-- Página {{ paginaActual }} de  {{ totalPaginas }} -->
                              <th colspan="12">
                                {{ PagPosActual }} de  {{ totalPagPos }} ({{
                                  totalRegistrosPos
                                }}
                                registros)
                              </th>
                            </tr>
                          </tfoot>
                    </table>
            </div>
        </div>
    </div>
  </section>

<!-- MODAL seleccionarRecorrido -->
<app-devolucion-mercaderia-modal-seleccionar-recorrido (onSelect)="onRecorridoSeleccionado($event)"
    (onNotFound)="onNotFoundRecorrido()">
</app-devolucion-mercaderia-modal-seleccionar-recorrido>

<!-- MODAL devolverDoc -->
<app-devolucion-mercaderia-modal-devolver-documento (onSuccess)="iniciarDevolucion(1)">
</app-devolucion-mercaderia-modal-devolver-documento>

<!-- MODAL devolverProduc -->
<app-devolucion-mercaderia-modal-devolver-producto [optionsMotivoGeneral]="optionsMotivoGeneral" (onSuccess)="iniciarDevolucion(1)">
</app-devolucion-mercaderia-modal-devolver-producto>
